import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
import { fetchFreshLeadsData } from "../../../redux/prospect-reducers/prospectSlice";
import FreshLeadListings from "./FreshLeadListings";
import ModalCloseStart from "../../payouts-wtf/common/ModalCloseStart";
import {
  getReplace1,
  isManagerRole as checkIsManagerRole,
} from "../../common-data/Conversions";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import AddLeadForm from "../AddLeadForm";
import LeadFollowupV1 from "../followup/LeadFollowupV1";
import CmnFilters from "../common/CmnFilters";
import CommonBroadForm from "../../common-components/broadcast-template/CommonBroadForm";
import LeadJourney from "../lms-v2/lead-journey/LeadJourney";
import ClickToCall from "../lms-v2/lms-payment-links/ClickToCall";

const FreshLeadStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { freshLeadsLoading } = useSelector((state) => state.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(5);
  const iniAllFilter = {
    selectedGym:
      isGym || (!isAdmin && !isMarketing && !isClusterManager && !isManagerRole)
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selAddedby: "",
    selAssignee:
      !isAdmin && !isMarketing && !isClusterManager && !isManagerRole
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    selLeadStatus: "",
    selAddNotAddToLead: "",
    selLeadSource: "",

    searchString: "",

    leadAddDateFrom: "",
    leadAddDateTo: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    assigned_to: allFilters.selAssignee?.value || "",
    added_by: allFilters.selAddedby?.value || "",
    lead_status: allFilters.selLeadStatus?.value || "",
    source_name: allFilters.selLeadSource?.value || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [isFilterSegmentShown, setIsFilterSegmentShown] = useState(true);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: null,
    selectedRows: [],
  };
  const [modValues, setModValues] = useState(iniModValues);

  // const isBroadcastCreateAllowed = isBroadcastCreateAllowedEmail(
  //   userInfoData?.email
  // );

  const ononCloseModal = () => {
    setModValues(iniModValues);
    setIsFilterSegmentShown(true);
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setIsPage(0);
    setSearchFilterApplied(false);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getAllLeads(filters) {
    dispatch(
      fetchFreshLeadsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getAllLeads(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,

      gym_id: allFilters.selectedGym?.value || "",
      assigned_to: allFilters.selAssignee?.value || "",
      added_by: allFilters.selAddedby?.value || "",
      lead_status: allFilters.selLeadStatus?.value || "",
      source_name: allFilters.selLeadSource?.value || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selAssignee,
    allFilters.selAddedby,
    allFilters.selLeadStatus,
    allFilters.selLeadSource,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.selAddNotAddToLead,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={ononCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "utm_parameters" ||
            modValues.modName === "broadcast_data"
              ? "mod-height-95vh broadcast-modal"
              : modValues.modName === "add-to-lead"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.modName === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : modValues.modName === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : ""
          }`}
        >
          {modValues.modName === "add-to-lead" ||
          modValues.modName === "click-to-call" ? null : modValues.modName ===
            "follow-up" ? (
            <ModalCloseStart
              title={`${getReplace1(modValues.modName)}`}
              onClose={() => {
                ononCloseModal();
              }}
            />
          ) : modValues.modName === "view-lead-journey" ? (
            <ModalCloseStart
              title={`Lead Details - ${modValues.rowData?.name || ""}`}
              onClose={() => {
                ononCloseModal();
              }}
            />
          ) : (
            <ModalHeadAndClose
              title={`${
                modValues.modName === "broadcast_data"
                  ? "New Broadcast Campaign"
                  : modValues.modName === "view_details"
                  ? `${getReplace1(modValues.from)} Lead - ${getReplace1(
                      modValues.rowData?.name || ""
                    )}`
                  : getReplace1(modValues.modName)
              }`}
              onClose={ononCloseModal}
            />
          )}

          {modValues.modName === "add-to-lead" ? (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={ononCloseModal}
              callFunction={() => getAllLeads(filters)}
              rowData={modValues.rowData}
              isFreshLead={true}
            />
          ) : modValues.modName === "follow-up" ? (
            <LeadFollowupV1
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeFollowupModal={ononCloseModal}
              isAllLeadDetails={true}
              pageName={"fresh-lead"}
              prevFilters={(({ limit, page, added_to_lead, ...rest }) => rest)(
                filters
              )}
            />
          ) : modValues.modName === "view-lead-journey" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "click-to-call" ? (
            <ClickToCall
              userInfoData={userInfoData}
              closeModal={ononCloseModal}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "broadcast_data" ? (
            <>
              {isFilterSegmentShown && (
                <CmnFilters
                  from={"fresh-lead"}
                  isSegment={true}
                  userInfoData={userInfoData}
                  onClickReset={onResetFilters}
                  filters={allFilters}
                  setFilters={setAllFilters}
                  isLoading={freshLeadsLoading}
                  isBroadcastModal={true}
                />
              )}

              <CommonBroadForm
                from={modValues.from}
                selectedTab={"fresh-lead"}
                filters={filters}
                allFilters={allFilters}
                userInfoData={userInfoData}
                onCloseModal={ononCloseModal}
                setIsFilterSegmentShown={setIsFilterSegmentShown}
              />
            </>
          ) : null}
        </div>
      </Modal>

      <Row>
        <Col>
          <PageHeadingNew
            heading="Fresh Leads"
            subheading="Not Converted Lead Before 31st March 2025"
            onReload={() => getAllLeads(filters)}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from="fresh-lead"
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            // onClickBroadcastBtn={
            //   isBroadcastCreateAllowed
            //     ? () =>
            //         setModValues((prevs) => ({
            //           ...prevs,
            //           isModOpen: true,
            //           modName: "broadcast_data",
            //           from: "fresh-lead",
            //         }))
            //     : null
            // }
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <FreshLeadListings
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setModValues={setModValues}
            callFunction={() => getAllLeads(filters)}
          />
        </Col>
      </Row>
    </>
  );
};

export default FreshLeadStructure;
